export const API =  process.env.VUE_APP_API
export const URL = process.env.VUE_APP_URL
export const captcha = process.env.VUE_APP_CAPTCHA
export const trustshare = process.env.VUE_APP_TRUSTSHARE_VERIFY
export const zaProducemart = process.env.VUE_APP_ZA
